import type { Testimonial } from '../types/content'

export const shortTestimonials: Testimonial[] = [
  {
    initials: 'RM',
    name: 'R.M.',
    role: 'Pickleball Instructor | London, UK',
    text: '“I used to spend my Sunday evenings rebuilding session plans from scratch. Now I open the library, pick the lesson, and walk onto the court completely prepared. My students feel the difference — and so do I.”',
  },
  {
    initials: 'DP',
    name: 'D.P.',
    role: 'Pickleball Instructor | Toronto, Canada',
    text: '“The 100 Common Mistakes & Coaching Cues guide alone saved me more times than I can count in my first month. That bonus is worth the full price by itself.”',
  },
  {
    initials: 'AK',
    name: 'A.K.',
    role: 'Pickleball Coach | Sydney, Australia',
    text: '“The Drills Library completely changed how I teach. My sessions are more dynamic, my players stay engaged, and every lesson feels intentional from the first drill to the last.”',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'VT',
    name: 'V.T.',
    role: 'Pickleball Instructor | New York, USA',
    text: "The doubles positioning progressions completely transformed how my players work together on the court. Every week genuinely feels like a real step forward — and I'm not the one scrambling to figure out what that step should be.",
  },
  {
    initials: 'CR',
    name: 'C.R.',
    role: 'Pickleball Coach | Melbourne, Australia',
    text: 'I used to get nervous when players of different levels showed up to the same group session. Now I open the system and I already have three versions of every concept ready before anyone arrives.',
  },
  {
    initials: 'DG',
    name: 'D.G.',
    role: 'Pickleball Instructor | Toronto, Canada',
    text: "I review the coaching cues before every session and I walk onto the court knowing exactly what I'm going to say. The Mistakes & Corrections guide is something I use every single week without exception.",
  },
  {
    initials: 'AM',
    name: 'A.M.',
    role: 'Pickleball Academy Instructor | London, UK',
    text: "The Assessment System saved my academy program. I had everything organized — skill evaluations, progress notes, lesson priorities — all in one place. My students could finally see exactly how far they'd come.",
  },
  {
    initials: 'SR',
    name: 'S.R.',
    role: 'Pickleball Coach | Dublin, Ireland',
    text: 'The competitive games and challenges were a total revelation. My players talk about those sessions for weeks. They feel like a real experience — not just another technical training block.',
  },
]
